var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.items}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }